import { useShallow } from 'zustand/shallow';

import { isEditMessageEnabled } from '@/feature/message.feature';
import { useMessagesStore } from '@/store/messages.store';
import Loading, { LoadingBall } from '@ingka/loading';
import { translate } from '@repo/phrase';
import type { AssetMessage } from '@repo/types/messages';
import { MessageList } from '@repo/ui/messages';

import { useAssetParams } from '@/hooks/asset.hooks';
import { getAppConfig } from '@/utils/window.utils';

import { useMessages } from '../../asset-message-modal.hooks';

export const AssetMessageModalAddContent = () => {
    const { assetType } = useAssetParams();
    const { activeTab, setMode, setDraftMessage, setMessageId } = useMessagesStore(
        useShallow((state) => ({
            activeTab: state.activeTab,
            messageId: state.messageId,
            setMode: state.setMode,
            setDraftMessage: state.setDraftMessage,
            setMessageId: state.setMessageId,
        }))
    );
    const { messages, isLoading } = useMessages(activeTab);
    const { dateTimeFormat } = getAppConfig();

    if (isLoading) {
        return (
            <Loading text={translate('loading_text')}>
                <LoadingBall color="primary" />
            </Loading>
        );
    }

    const onMessageClick = (message: AssetMessage) => {
        setMode('edit');
        setDraftMessage(message.messageText);
        setMessageId(message.orderMessageId);
    };

    return (
        <MessageList
            enableEdit={isEditMessageEnabled(assetType, activeTab)}
            messages={messages}
            messageType={activeTab}
            translate={translate}
            onMessageClick={onMessageClick}
            dateTimeFormat={dateTimeFormat}
        />
    );
};
